<template>
    <div>
        <ConfirmDialog
            :is-open="showConfirmDialog"
            :data="confirmDialogData"
            @on-confirm="confirmDialogConfirm"
            @on-abort="confirmDialogClose"
        >
            <template #title>
                {{ confirmDialogData.title }}
            </template>
            <template #content>
                {{ confirmDialogData.content }}
            </template>
        </ConfirmDialog>
        <CampaignDistributionCenterDialog
            :is-open="showCampaignDistributionCenterDialog"
            :distribution-center-data="currentDistributionCenter"
            @on-save="saveCampaignDistributionCenterDialog"
            @on-close="closeCampaignDistributionCenterDialog"
        />
        <CampaignDistributionCenterSetDialog
            :is-open="showCampaignDistributionCenterSetDialog"
            :distribution-center-set-data="currentSet"
            :set-list="filteredSetList(currentDistributionCenter)"
            @on-save="saveCampaignDistributionCenterSetDialog"
            @on-close="closeCampaignDistributionCenterSetDialog"
        />
        <v-card flat>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-tooltip :open-delay="tooltipDelay" top>
                            <template #activator="{on}">
                                <v-btn
                                    fab
                                    color="secondary"
                                    x-small
                                    elevation="1"
                                    class="mr-9 mt-1"
                                    data-sentry-label="Dodaj"
                                    :disabled="!isEditAllowed"
                                    v-on="on"
                                    @click="createCampaignDistributionCenterDialog"
                                >
                                    <v-icon color="white">
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Dodaj centrum dystrybucji</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-expansion-panels
                            accordion
                        >
                            <v-expansion-panel
                                v-for="distributionCenter in distributionCenters"
                                :key="distributionCenter.id"
                            >
                                <v-expansion-panel-header>
                                    <v-row 
                                        no-gutters 
                                        align="center" 
                                        dense
                                        class="mt-2"
                                    >
                                        <v-col cols="12" sm="8">
                                            Nazwa: <strong>{{ distributionCenter.name }}</strong>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-container fluid class="pa-0">
                                                <v-row justify="end" dense>
                                                    <v-tooltip
                                                        :open-delay="tooltipDelay"
                                                        top
                                                    >
                                                        <template #activator="{on}">
                                                            <v-btn
                                                                icon
                                                                data-sentry-label="Edycja centrum dystrybucji"
                                                                :disabled="!isEditAllowed"
                                                                v-on="on"
                                                                @click="openEditCampaignDistributionCenterDialog(distributionCenter)"
                                                            >
                                                                <v-icon color="teal">
                                                                    mdi-pencil
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Edycja centrum dystrybucji</span>
                                                    </v-tooltip>
                                                    <v-tooltip
                                                        :open-delay="tooltipDelay"
                                                        top
                                                    >
                                                        <template #activator="{on}">
                                                            <v-btn
                                                                icon
                                                                data-sentry-label="Usuń entrum distribucji"
                                                                :disabled="!isEditAllowed"
                                                                v-on="on"
                                                                @click="tryDeleteDistributionCenter(distributionCenter)"
                                                            >
                                                                <v-icon color="pink">
                                                                    mdi-delete
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Usuń centrum dystrybucji</span>
                                                    </v-tooltip>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>

                                <v-divider />

                                <!--  Produkty -->
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                        >
                                            <v-tooltip :open-delay="tooltipDelay" top>
                                                <template #activator="{on}">
                                                    <v-btn
                                                        fab
                                                        color="secondary"
                                                        x-small
                                                        elevation="1"
                                                        class="mr-9 mt-1"
                                                        data-sentry-label="Dodaj zestaw"
                                                        :disabled="!isEditAllowed"
                                                        v-on="on"
                                                        @click="createCampaignDistributionCenterSetDialog(distributionCenter)"
                                                    >
                                                        <v-icon color="white">
                                                            mdi-plus
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Dodaj zestaw</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-data-table
                                        :headers="distributionCentersHeaders"
                                        :items="distributionCenter.productSets"
                                        dense
                                        :loading="loading"
                                        item-key="id"
                                        :mobile-breakpoint="0"
                                        no-data-text="Brak danych"
                                        :items-per-page="17"
                                        hide-default-footer
                                        class="elevation-1"
                                    >
                                        <template #item.name="{item}">
                                            {{ item.productSet.name }}
                                        </template>
                                        <template #item.EAN="{item}">
                                            {{ item.productSet.EAN }}
                                        </template>
                                        <template #item.index="{item}">
                                            {{ item.productSet.index }}
                                        </template>
                                        <template #item.amount="{item}">
                                            {{ item.amount }}
                                        </template>
                                        <template #item.actions="{item}">
                                            <div justify="end" class="pa-2 text-end">
                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-btn
                                                            icon
                                                            data-sentry-label="Edytuj"
                                                            :disabled="!isEditAllowed"
                                                            v-on="on"
                                                            @click="openEditCampaignDistributionCenterSetDialog(distributionCenter, item)"
                                                        >
                                                            <v-icon color="teal">
                                                                mdi-pencil
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Edytuj</span>
                                                </v-tooltip>
                                                <v-tooltip
                                                    :open-delay="tooltipDelay"
                                                    top
                                                >
                                                    <template #activator="{on}">
                                                        <v-btn
                                                            icon
                                                            data-sentry-label="Usuń"
                                                            :disabled="!isEditAllowed"
                                                            v-on="on"
                                                            @click="tryDeleteDistributionCenterSet(distributionCenter, item)"
                                                        >
                                                            <v-icon color="pink">
                                                                mdi-delete
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Usuń</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import CampaignDistributionCenterDialog from '@/views/Campaigns/Dialogs/CampaignDistributionCenterDialog'
import CampaignDistributionCenterSetDialog from '@/views/Campaigns/Dialogs/CampaignDistributionCenterSetDialog'

export default {
    name: 'DistributionCentersList',
    components: {
        CampaignDistributionCenterDialog,
        ConfirmDialog,
        CampaignDistributionCenterSetDialog
    },
    props: {
        loading: {
            type: Boolean,
        },
        distributionCenters: {
            type: Array,
            default: () => [],
        },
        campaignId: {
            type: Number,
            required: true,
        },
        productSets: {
            type: Array,
            default: () => [],
        },
        isEditAllowed: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            currentDistributionCenter: null,
            currentSet: null,
            distributionCentersHeaders: [
                {
                    text: 'Nazwa',
                    value: 'name',
                },
                {
                    text: 'Kod EAN',
                    value: 'EAN',
                },
                {
                    text: 'Index',
                    value: 'index',
                },
                {
                    text: 'Ilość',
                    value: 'amount',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 120,

                },
            ],
            tooltipDelay: 500,
            showCampaignDistributionCenterDialog: false,
            showCampaignDistributionCenterSetDialog: false,
            showConfirmDialog: false,
            confirmDialogData: {
                confirm: () => {},
            },
        }
    },
    methods: {
        createCampaignDistributionCenterDialog() {
            this.currentDistributionCenter = null
            this.showCampaignDistributionCenterDialog = true
        },
        createCampaignDistributionCenterSetDialog(distributionCenter) {
            this.currentDistributionCenter = distributionCenter
            this.currentSet = null
            this.showCampaignDistributionCenterSetDialog = true
        },
        openEditCampaignDistributionCenterDialog(distributionCenter) {
            this.currentDistributionCenter = distributionCenter
            this.showCampaignDistributionCenterDialog = true
        },
        openEditCampaignDistributionCenterSetDialog(distributionCenter, distributionCenterSet) {
            this.currentDistributionCenter = distributionCenter
            this.currentSet = distributionCenterSet
            this.showCampaignDistributionCenterSetDialog = true
        },
        saveCampaignDistributionCenterDialog(distributionCenter) {
            if (this.currentDistributionCenter) {
                this.updateDistributionCenter(distributionCenter)
            } else {
                this.createDistributionCenter(distributionCenter)
            }
        },
        filteredSetList(distributionCenter) {
            if (!distributionCenter) {
                return this.productSets
            }

            return this.productSets.filter(set => {
                return !distributionCenter.productSets.some(distributionCenterSet => distributionCenterSet.productSetId === set.id)
            })
        },
        saveCampaignDistributionCenterSetDialog(distributionCenterSet) {
            let updatedDistributionCenter = Object.assign({}, this.currentDistributionCenter)

            if (this.currentSet) {
                let index = updatedDistributionCenter.productSets.findIndex(set => set.id === distributionCenterSet.id)

                if (index != -1 ) {
                    updatedDistributionCenter.productSets[index] = distributionCenterSet
                }
            } else {
                updatedDistributionCenter.productSets.push(distributionCenterSet)
            }

            this.updateDistributionCenter(updatedDistributionCenter)
        },
        deleteCampaignDistributionCenterSet({ data }) {
            let updatedDistributionCenter = Object.assign({}, data.distributionCenter)

            let index = updatedDistributionCenter.productSets.findIndex(set => set.id === data.distributionCenterSet.id)

            if (index != -1 ) {
                updatedDistributionCenter.productSets.splice(index, 1)
            }

            this.updateDistributionCenter(updatedDistributionCenter)
        },
        updateDistributionCenter(distributionCenter) {
            this.$store.dispatch('campaigns/updateCampaignDistributionCenter', {
                ...this.currentDistributionCenter,
                ...distributionCenter
            })
                .then(() => {
                    this.$emit('distribution-center-changed', () => {
                        this.$store.dispatch('showNotification', {
                            type: 'success',
                            message: 'Centrum dystrybucji zostało zaktualizowane.'
                        })
                    })
                })
                .finally(() => {
                    this.closeCampaignDistributionCenterDialog()
                    this.closeCampaignDistributionCenterSetDialog()
                })
        },
        createDistributionCenter(distributionCenter) {
            this.$store.dispatch('campaigns/createCampaignDistributionCenter', {
                ...distributionCenter,
                campaignId: this.campaignId,
            })
                .then(() => {
                    this.$emit('distribution-center-changed', () => {
                        this.$store.dispatch('showNotification', {
                            type: 'success',
                            message: 'Centrum dystrybucji zostało dodane.'
                        })
                    })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeCampaignDistributionCenterDialog()
                })
        },
        deleteCampaignDistributionCenter({ data }) {
            this.$store.dispatch('campaigns/deleteCampaignDistributionCenter', data.id)
                .then(() => {
                    this.$emit('distribution-center-changed', () => {
                        this.$store.dispatch('showNotification', {
                            type: 'success',
                            message: 'Centrum dystrybucji zostało usunięte.'
                        })
                    })
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closeCampaignDistributionCenterDialog() {
            this.currentDistributionCenter = null
            this.showCampaignDistributionCenterDialog = false
        },
        closeCampaignDistributionCenterSetDialog() {
            this.currentSet = null
            this.showCampaignDistributionCenterSetDialog = false
        },
        tryDeleteDistributionCenter(distributionCenter) {
            this.confirmDialogData = {
                title: 'Usuwanie centrum dystrybucji',
                content: 'Czy na pewno chcesz usunąć centrum dystrybucji?',
                confirm: this.deleteCampaignDistributionCenter,
                data: distributionCenter,
            }
            this.showConfirmDialog = true
        },
        tryDeleteDistributionCenterSet(distributionCenter, distributionCenterSet) {
            this.confirmDialogData = {
                title: 'Usuwanie zestawu centrum dystrybucji',
                content: 'Czy na pewno chcesz usunąć zestaw centrum dystrybucji?',
                confirm: this.deleteCampaignDistributionCenterSet,
                data: { distributionCenter, distributionCenterSet }
            }
            this.showConfirmDialog = true
        },
        confirmDialogConfirm(payload) {
            this.confirmDialogData.confirm(payload)
            this.confirmDialogClose()
        },
        confirmDialogClose() {
            this.showConfirmDialog = false
            setTimeout(() => {
                this.confirmDialogData = {
                    title: null,
                    content: null,
                    confirm: () => {},
                    data: null,
                }
            }, 500)
        },
    },
}
</script>